import 'ui-core/components/facet/js/toggle';

var $body = $('body');

UX.toggle.control = function () {
    $body.on('click', '.facet .show-more', function (e) {
        e.preventDefault();
        UX.toggle.on.toggle($(this));
    });
    $body.on('click', '.facet a.dropdown__toggle', function (e) {
        if ($(e.target).is('span')) location.href = $(this).attr('href');
        else if ($(e.target).is('.facet__toggle')) {
            e.preventDefault();
            UX.toggle.on.toggleFacet($(this));
        }
    });

    $body.on('click keydown', '.facet a.dropdown__toggle .facet__toggle', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            UX.toggle.on.toggleFacet($(this));
        }
    });
};
